module.exports = __webpack_public_path__ + "static/media/icon-feedback.44fb8c73.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/icon-feedback.png
// module id = 1883
// module chunks = 6